import { render, staticRenderFns } from "./ApexPieChart.vue?vue&type=template&id=31148c3c&scoped=true"
import script from "./ApexPieChart.vue?vue&type=script&lang=ts"
export * from "./ApexPieChart.vue?vue&type=script&lang=ts"
import style0 from "./ApexPieChart.vue?vue&type=style&index=0&id=31148c3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31148c3c",
  null
  
)

export default component.exports